// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"b56cb803","315":"1b40f55b","326":"fa3dff20","418":"94c6dc46","501":"8abf39e2","608":"2d03bc54","630":"a31631e8","930":"2161e354"}[chunkId] + ".chunk.js";
};